import styled, { css } from 'styled-components';

import { BoxProps } from '../box';
import colors from '../../style/colors';
import BaseCard from './base-card';

export const variants = {
  default: css`
    background: ${colors.white};
    border: 1px solid ${colors.gray300};
  `,
  'violet-border': css`
    background: ${colors.white};
    border: 1px solid ${colors.violet};
  `,
  'bubbleGum-border': css`
    background: ${colors.white};
    border: 1px solid ${colors.bubbleGum};
  `,
  'pumpkin-border': css`
    background: ${colors.white};
    border: 1px solid ${colors.pumpkin};
  `,
  violet: css`
    background: ${colors.violet};
    border: 1px solid ${colors.violet};
  `,
  bubbleGum: css`
    background: ${colors.bubbleGum};
    border: 1px solid ${colors.bubbleGum};
  `,
  pumpkin: css`
    background: ${colors.pumpkin};
    border: 1px solid ${colors.pumpkin};
  `,
  'ametystPurple-border': css`
    background: ${colors.white};
    border: 1px solid ${colors.ametystPurple};
  `,
  'raspberryPink-border': css`
    background: ${colors.white};
    border: 1px solid ${colors.raspberryPink};
  `,
  'amberGlow-border': css`
    background: ${colors.white};
    border: 1px solid ${colors.amberGlow};
  `,
  ametystPurple: css`
    background: ${colors.ametystPurple};
    border: 1px solid ${colors.lightAmetystPurple};
    border-radius: 16px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  `,
  raspberryPink: css`
    background: ${colors.raspberryPink};
    border: 1px solid ${colors.lightRaspberryPink};
    border-radius: 16px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  `,
  amberGlow: css`
    background: ${colors.amberGlow};
    border: 1px solid ${colors.lightPumpkin};
    border-radius: 16px;
    box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
  `,
};

export interface ShadowCardBorderProps extends BoxProps {
  variant?: keyof typeof variants;
}

const ShadowCardBorder = styled(BaseCard).withConfig({
  shouldForwardProp: prop => !['variant'].includes(prop),
})<ShadowCardBorderProps>`
  transition: all 600ms ease;
  box-shadow: 0 4px 4px -4px rgba(0, 0, 0, 0.12);
  border-radius: 8px;

  ${props => variants[props.variant || 'default']};

  &:hover:not(.disabled):not([disabled]) {
    box-shadow: 0 8px 8px -4px rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }

  &:focus-visible,
  &.active {
    border-color: ${props => props.theme.actionColor};
  }
`;

export default ShadowCardBorder;
